import { useMemo } from 'react'
import styles from './Header.module.scss'
import { ROUTES } from '@/app/routes.constants'
import { Button } from '@/ui/button'
import { MaterialIcon } from '@/ui/material-icon'
import { Separator } from '@/ui/separator'
import Breadcrumb from '@/shared/components/Breadcrumb/Breadcrumb'
import AkashicLogo from '@/assets/logo/akashic-logo.svg?react';

const Header = () => {
  const breadcrumbItems = useMemo(
    () => [
      { label: 'Home', to: ROUTES.AKASHIC_LANDING },
      'Akashic Data Pipeline',
      'Assets'
    ],
    []
  )

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <AkashicLogo />
        <Separator orientation="vertical" className='h-full' />
        <Breadcrumb items={breadcrumbItems} className={styles.headerBreadcrumb} />
      </div>
      <div className={styles.headerRight}>
        <Button type="button" variant="ghost" size="icon" aria-label="Notifications">
          <MaterialIcon name="notifications" size={22} />
        </Button>
        <img className={styles.avatar} src="https://i.pravatar.cc/56?img=12" alt="" />
      </div>
    </header>
  )
}

export default Header
